import { render, staticRenderFns } from "./UpdateFormatFile.vue?vue&type=template&id=cd970612"
import script from "./UpdateFormatFile.vue?vue&type=script&lang=js"
export * from "./UpdateFormatFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports